import styled from 'styled-components';
import { motion, useInView } from 'motion/react';
import React, { PropsWithChildren, useRef } from 'react';
import { ANIMATION_CONFIG } from '../../../constants/animationConfig';

interface MotionTextProps extends PropsWithChildren {
  yOffset?: number;
  duration?: number;
  delay?: number;
  className?: string;
}

export const MotionText = ({
  children,
  yOffset = ANIMATION_CONFIG.text.yOffset,
  duration = ANIMATION_CONFIG.text.duration,
  delay = ANIMATION_CONFIG.text.delay,
  className
}: MotionTextProps) => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    amount: ANIMATION_CONFIG.text.amount,
  });
    
  return (
    <MotionTextWrapper 
      ref={ref}
      className={className}
      initial={{ opacity: 0, y: yOffset }}
      animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: yOffset }}
      transition={{
        duration: duration,
        delay: delay,
        type: 'spring',
      }}
    >
      {children}
    </MotionTextWrapper>
  );
};

const MotionTextWrapper = styled(motion.div)`
  display: inline-block;
`;
